import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "directions" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-import mr-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1)
const _hoisted_6 = { class: "flex items-center justify-end mt-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1)
const _hoisted_9 = { class: "mt-6" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_directions_actions = _resolveComponent("directions-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_directions_actions, {
          key: 0,
          loading: _ctx.actions_state.is_actions_loading,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "is-delete": _ctx.actions_state.is_delete,
          "initial-value": _ctx.actions_state.initial_value,
          onCreate: _ctx.createDirection,
          onUpdate: _ctx.updateDirection,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false))
        }, null, 8, ["loading", "is-create", "is-update", "is-delete", "initial-value", "onCreate", "onUpdate"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_page_title, { title: "Направления" }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/directions/import",
            class: "mr-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_button, { class: "primary text small" }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createTextVNode(" Импортировать из Excel ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_the_button, {
            class: "primary small",
            onClick: _ctx.startCreate
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" Добавить направление ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("form", {
        class: "mt-6 bg-white border px-6 py-4",
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchDirection && _ctx.searchDirection(...args)), ["prevent"]))
      }, [
        _createVNode(_component_the_select, {
          "can-deselect": "",
          value: _ctx.filters_state.from_city_id,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.from_city_id) = $event)),
          placeholder: "Откуда",
          loading: _ctx.data_state.from_cities.is_loading,
          options: _ctx.data_state.from_cities.list,
          failed: _ctx.data_state.from_cities.is_failed,
          "error-text": "При получении списка городов произошла ошибка",
          "search-by": "name",
          label: "name",
          "infinite-scroll": "",
          onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadFromCities(_ctx.data_state.from_cities.pagination.current_page))),
          onLoadmore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMoreFromCities(_ctx.data_state.from_cities.pagination.current_page + 1))),
          onSearch: _ctx.searchFromCity,
          onOptionBySearch: _ctx.unshiftFindedFromCity
        }, null, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
        _createVNode(_component_the_select, {
          "can-deselect": "",
          value: _ctx.filters_state.where_city_id,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters_state.where_city_id) = $event)),
          placeholder: "Куда",
          loading: _ctx.data_state.where_cities.is_loading,
          options: _ctx.data_state.where_cities.list,
          failed: _ctx.data_state.where_cities.is_failed,
          "error-text": "При получении списка городов произошла ошибка",
          "search-by": "name",
          label: "name",
          "infinite-scroll": "",
          onRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadWhereCities(_ctx.data_state.where_cities.pagination.current_page))),
          onLoadmore: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadMoreWhereCities(_ctx.data_state.where_cities.pagination.current_page + 1))),
          onSearch: _ctx.searchWhereCity,
          onOptionBySearch: _ctx.unshiftFindedWhereCity,
          class: "mt-3"
        }, null, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_the_button, {
            class: "second text small mr-2",
            loading: _ctx.state.is_loading,
            onClick: _ctx.resetFilters
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createTextVNode(" Сброс ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]),
          _createVNode(_component_the_button, {
            class: "primary text small",
            loading: _ctx.state.is_loading,
            type: "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createTextVNode(" Поиск ")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.state.is_loading,
              text: "При получении списка направлений произошла ошибка",
              "error-message": _ctx.state.failure.error_state.message,
              "error-url": _ctx.state.failure.error_state.url,
              "error-status": _ctx.state.failure.error_state.status,
              onRefresh: _ctx.loadDirections
            }, null, 8, ["loading", "error-message", "error-url", "error-status", "onRefresh"]))
          : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
              key: 1,
              loading: _ctx.state.is_loading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_table, {
                  loading: _ctx.state.is_loading,
                  columns: _ctx.DirectionsColumns,
                  rows: _ctx.state.list,
                  "with-limit": "",
                  "pagination-limit": _ctx.filters_state.limit,
                  "pagination-total-items": _ctx.state.pagination.total_items,
                  "pagination-current-page": _ctx.state.pagination.current_page,
                  "pagination-total-pages": _ctx.state.pagination.total_pages,
                  onChangePage: _ctx.loadDirections,
                  onChangeLimit: _ctx.onLimitChange
                }, {
                  td: _withCtx(({ column, row }) => [
                    (column.key === 'status')
                      ? (_openBlock(), _createBlock(_component_cheap, {
                          key: 0,
                          class: _normalizeClass(["small w-min", { green: row.isActive, red: !row.isActive }])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.isActive ? 'Активно' : 'Не активно'), 1)
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      : (column.key === 'direction')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(row.fromCityName) + " - " + _toDisplayString(row.whereCityName), 1)
                          ], 64))
                        : (column.key === 'isNearbyCities')
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 2,
                              class: _normalizeClass(_ctx.getCheckOrTimesIcon(row.isNearbyCities))
                            }, null, 2))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                            ], 64))
                  ]),
                  actions: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_the_button, {
                        hint: "Редактировать",
                        class: "primary extra-small",
                        onClick: ($event: any) => (_ctx.startUpdate(row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      (_ctx.havePermissions(['location.direction-destroy']))
                        ? (_openBlock(), _createBlock(_component_the_button, {
                            key: 0,
                            hint: "Удалить",
                            class: "red extra-small ml-2",
                            onClick: ($event: any) => (_ctx.deleteDirection(row.id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
              ]),
              _: 1
            }, 8, ["loading"]))
      ])
    ])
  ], 64))
}